import React from 'react';
import {ListContent, processTranslation} from '../utils/commonUtil';
import {isPPM} from '../../utils/validate';
import {BRAND_NAME} from '../../utils/constants';

const getListContent = (translations, userType, siteName, isSWSv2FlowEnabled) => {
    let contents;
    switch (userType) {
        case 'IPM_SOFTWARE_SWITCH':
            contents = [
                processTranslation(translations['ipmob.introduction.description_2'], [BRAND_NAME.vrbo]),
                translations['ipmob.introduction.description_3'],
                translations['ipmob.introduction.description_4'],
                translations['ipmob.introduction.description_6'],
                translations['ipmob.introduction.description_7'],
                translations['ipmob.introduction.description_8'],
                translations['ipmob.introduction.description_9'],
                translations['ipmob.introduction.description_12'],
                translations['ipmob.introduction.description_13'],
                translations['ipmob.introduction.description_14'],
                processTranslation(translations['ipmob.introduction.description_15'], [BRAND_NAME.vrbo]),
                translations['ipmob.introduction.description_17']
            ];

            if (isSWSv2FlowEnabled) {
                const removeDecommissionRelatedKeys = [translations['ipmob.introduction.description_14'], processTranslation(translations['ipmob.introduction.description_15'], [BRAND_NAME.vrbo])];
                contents = contents.filter(item => !removeDecommissionRelatedKeys.includes(item));
            }
            break;
        case 'PPM':
        case 'IPM':
        default:
            contents = [
                processTranslation(translations['ipmob.introduction.description_2'], [BRAND_NAME.vrbo]),
                translations['ipmob.introduction.description_3'],
                translations['ipmob.introduction.description_4'],
                translations['ipmob.introduction.description_6'],
                translations['ipmob.introduction.description_7'],
                translations['ipmob.introduction.description_8'],
                translations['ipmob.introduction.description_9'],
                translations['ipmob.introduction.description_12'],
                translations['ipmob.introduction.description_13'],
                translations['ipmob.introduction.description_17']
            ];
            break;
    }
    if (siteName === 'homeaway_au' || siteName === 'homeaway_nz') {
        const removePaymentRelatedKeys = [translations['ipmob.introduction.description_13']];
        contents = contents.filter(item => !removePaymentRelatedKeys.includes(item));
    }

    return contents;
}

const getPMIntroContents = (translations, userType, siteName, isSWSv2FlowEnabled) => {
    const contentList = getListContent(translations, userType, siteName, isSWSv2FlowEnabled);
    const descListKeys = [];

    if (isPPM(userType)) {
        descListKeys.push('ipmob.ppm.introduction.description_2');
        descListKeys.push('ipmob.ppm.introduction.description_3');
    } else {
        descListKeys.push('ipmob.introduction.description_10');
        descListKeys.push('ipmob.introduction.description_11');
    }

    return (
        <div>
            <div className="content-description_1"> {translations[descListKeys[0]]} </div>
            <div className="content-description_2"> {translations[descListKeys[1]]} </div>
            <div className="content-description_3"> {translations['ipmob.introduction.description_16']} </div>
            <div className="content-description-list">
                <ListContent
                    contentList={contentList}
                    listItemClass="list-content-item"
                />
            </div>
        </div>
    );
};

const getIPMIntroContents = (translations, userType, siteName, isSWSv2FlowEnabled) => {
    const contentList = getListContent(translations, userType, siteName, isSWSv2FlowEnabled);

    return (
        <div>
            <div className="content-description_3"> {translations['ipmob.introduction.description_16']} </div>
            <div className="content-description-list">
                <ListContent
                    contentList={contentList}
                    listItemClass="list-content-item"
                />
            </div>
        </div>
    );
};

const getHeadingDesc = (translations, userType) => (userType === 'PPM') ? '' : translations['ipmob.introduction.heading_2'];

const getIntroductionContents = (userType, translations, firstName, siteName, isSWSv2FlowEnabled) => {
    let introductionContents;

    switch (userType) {
        case 'IPM_SOFTWARE_SWITCH':
        case 'PPM':
            introductionContents = {
                styles: {
                    width: 576,
                    height: 602,
                    innerPadding: 48,
                    outerPaddingTop: 10,
                    outerPaddingBottom: 10
                },
                heading: translations['ipmob.ppm.introduction.heading'],
                headingDesc: getHeadingDesc(translations, userType),
                dialogHeading: processTranslation(translations['ipmob.ppm.introduction.description_1'], [firstName]),
                contents: getPMIntroContents(translations, userType, siteName, isSWSv2FlowEnabled)
            };
            break;
        case 'IPM':
        default:
            introductionContents = {
                styles: {
                    width: 576,
                    height: 450,
                    innerPadding: 48,
                    outerPaddingTop: 10,
                    outerPaddingBottom: 10
                },
                heading: translations['ipmob.introduction.heading'],
                headingDesc: '',
                dialogHeading: processTranslation(translations['ipmob.ppm.introduction.description_1'], [firstName]),
                contents: getIPMIntroContents(translations, userType, siteName, isSWSv2FlowEnabled)
            };
            break;
    }

    return introductionContents;
};

export { getIntroductionContents };
